module.exports = __webpack_public_path__ + "static/media/bottom-bars@3x.fb6e0af4.png";